import { useEffect, useRef } from "react";

type UseSetNavigationWidthProps = {
  headerWidth: number;
  isFromHome?: boolean;
};

/**
 * Custom hook to set the width of navigation containers based on header width.
 * Adjusts the width of navRightContainer and navLeftContainer based on the headerWidth.
 */

export const useSetNavigationWidth = ({
  headerWidth,
  isFromHome,
}: UseSetNavigationWidthProps) => {
  const navRightContainerRef = useRef<HTMLDivElement>(null);
  const navLeftContainerRef = useRef<HTMLDivElement>(null);
  const widthToDisplayTwo = 1580;
  const widthToDisplayAll = 1600;

  useEffect(() => {
    if (
      headerWidth >= widthToDisplayTwo &&
      headerWidth < widthToDisplayAll &&
      navRightContainerRef.current &&
      navLeftContainerRef.current
    ) {
      navRightContainerRef.current.style.width = "220px";
      if (isFromHome) navLeftContainerRef.current.style.overflow = "hidden";
      return;
    }

    if (
      headerWidth >= widthToDisplayAll &&
      navRightContainerRef.current &&
      navLeftContainerRef.current
    ) {
      navRightContainerRef.current.style.width = "auto";
      if (isFromHome) navLeftContainerRef.current.style.overflow = "visible";
      return;
    }

    if (navRightContainerRef.current && navLeftContainerRef.current) {
      navRightContainerRef.current.style.width = "100px";
      if (isFromHome) navLeftContainerRef.current.style.overflow = "hidden";
    }
  }, [headerWidth, isFromHome]);

  return {
    navRightContainerRef,
    navLeftContainerRef,
  };
};
